import keys from '@debbie/common/dist/cache/keys.js';
import * as api from '../api/billing-appendix-setups.js';
import q from '../query.js';
export const billingAppendixSetupsEntity = `billing-appendix-setups`;
const billingAppendixSetupsKey = `billing-appendix-setups`;
export const useBillingAppendixSetups = () => q.query(billingAppendixSetupsKey, api.get, keys.read.collection(billingAppendixSetupsEntity));
//# sourceMappingURL=index.js.map